import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { I18nNamespace } from '~/common/types';

import { ToolResultComponent } from '.';

export const RunContractItemDiscovery: ToolResultComponent<
  Tool.runContractItemDiscovery,
  Record<string, unknown>,
  Record<string, unknown>
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });
  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t(`call`)} />;

    case 'output-available': {
      return <ChatToolResultIndicator message={t(`result`)} disabled={true} />;
    }
  }
};
